import { IssueResolutionEnum } from '@issuemanager/constants';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface SelectOption {
  label: string;
  value: string;
}

export const useResolutionOptions = (): SelectOption[] => {
  const { t } = useTranslation('common');

  return useMemo(
    () => [
      {
        label: t('issueResolution.notAccepted'),
        value: IssueResolutionEnum.NOT_ACCEPTED,
      },
      {
        label: t('issueResolution.resolved'),
        value: IssueResolutionEnum.RESOLVED,
      },
      {
        label: t('issueResolution.unresolved'),
        value: IssueResolutionEnum.UNRESOLVED,
      },
    ],
    [t],
  );
};
